import { mmFetch } from './mmFetch';
import { mmFetchWithResponse } from './mmFetchWithResponse';

const doorDashApi = {
    bulkDownloadBOLs: async (facilityID, lineHaulName, deliveryDate) => {
        const url = `api/wholesale/v1/doordash/orders/bulkOrderBOLs?facilityID=${facilityID}&lineHaul=${lineHaulName}&deliveryDate=${deliveryDate}`;

        const respObj = {
            status: true,
            data: {},
            msg: '',
        };

        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                if (blob.type === 'application/json') {
                    return respObj;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = `bulk_BOLS_${lineHaulName}_${deliveryDate}_` + `.html`;
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(res);
                    }
                }, 200);
            } else {
                const decodedResp = await res.json();
                respObj.msg = decodedResp.msg;
                respObj.status = false;
            }
        } catch (e) {
            console.error('[doorDashApi - bulkDownloadBOLs] error', e.toString());
            respObj.msg = e.toString();
            respObj.status = false;
        }

        return respObj;
    },
    bulkDownloadPackSlips: async (facilityID, lineHaulName, deliveryDate) => {
        const url = `api/wholesale/v1/doordash/orders/bulkOrderPackSlips?facilityID=${facilityID}&lineHaul=${lineHaulName}&deliveryDate=${deliveryDate}`;

        const respObj = {
            status: true,
            data: {},
            msg: '',
        };

        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                if (blob.type === 'application/json') {
                    return respObj;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = `bulk_packslips_${lineHaulName}_${deliveryDate}_` + `.pdf`;
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(res);
                    }
                }, 200);
            } else {
                const decodedResp = await res.json();
                respObj.msg = decodedResp.msg;
                respObj.status = false;
            }
        } catch (e) {
            console.error('[doorDashApi - bulkDownloadPackSlips] error', e.toString());
            respObj.msg = e.toString();
            respObj.status = false;
        }

        return respObj;
    },
    cancelOrder: async (purchaseOrderName) => {
        const url = `api/wholesale/v1/doordash/orders/${purchaseOrderName}/cancel`;
        const response = await mmFetchWithResponse(url, {
            method: 'PUT',
        });
        return response;
    },
    confirmAllocationUpload: async (key) => {
        const url = 'api/wholesale/v1/doordash/allocation/bulk';
        const response = await mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({ key }),
        });
        return response;
    },
    confirmOrderUpload: async (key) => {
        const url = 'api/wholesale/v1/doordash/orders/bulk';
        const response = await mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({ key }),
        });
        return response;
    },
    confirmPricingUpload: async (key) => {
        const url = 'api/wholesale/v1/doordash/pricing/upload';
        const response = await mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify({ key }),
        });
        return response;
    },
    createMicroFulfillmentCenter: async (item) => {
        const url = `api/wholesale/v1/doordash/microFC`;
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(item),
        });
        return response;
    },
    downloadAllocationCsv: async (facilityID, deliveryDate) => {
        const url = `api/wholesale/v1/doordash/allocation/csv?facilityID=${facilityID}&deliveryDate=${deliveryDate}`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = `doorDashAlloction${facilityID}.csv`;
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(res);
                    }
                }, 200);
            }
        } catch (e) {
            console.error('[doorDashApi - downloadAllocationCsv] error', e.toString());
        }
    },
    downloadBOL: async (shipmentID) => {
        const url = `api/wholesale/v1/doordash/orders/bol/${shipmentID}`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = `bol${shipmentID}.html`;
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(res);
                    }
                }, 200);
            }
        } catch (e) {
            console.error('[doorDashApi - downloadBOL] error', e.toString());
        }
    },
    downloadInvoiceCsv: async (invoiceID) => {
        const url = `api/wholesale/v1/doordash/invoices/${invoiceID}/csv`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = `doorDashInvoice${invoiceID}.csv`;
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(res);
                    }
                }, 200);
            }
        } catch (e) {
            console.error('[doorDashApi - downloadInvoiceCsv] error', e.toString());
        }
    },
    downloadPackSlip: async (shipmentID) => {
        const url = `api/wholesale/v1/doordash/orders/packSlip/${shipmentID}`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = `packslip${shipmentID}.pdf`;
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(res);
                    }
                }, 200);
            }
        } catch (e) {
            console.error('[doorDashApi - getPackSlip] error', e.toString());
        }
    },
    getAllocationRollup: async (facilityID) => {
        const url = `api/wholesale/v1/doordash/allocation/rollup?facilityID=${facilityID}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getLineHaulsWithOrders: async (facilityID) => {
        const url = `api/wholesale/v1/doordash/lineHauls?facilityID=${facilityID}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getMicroFulfillmentCenters: async () => {
        const url = `api/wholesale/v1/doordash/microFC`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getInvoices: async (startDate, endDate, facilityID) => {
        const url = `api/wholesale/v1/doordash/invoices?startDate=${startDate}&endDate=${endDate}&facilityID=${facilityID}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getOrders: async (facilityID) => {
        const url = `api/wholesale/v1/doordash/orders?facilityID=${facilityID}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getOrdersByLineHauls: async (facilityID, lineHaul, deliveryDate = null) => {
        const url = `api/wholesale/v1/doordash/ordersByLineHaul?facilityID=${facilityID}&lineHaul=${lineHaul}&deliveryDate=${deliveryDate}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getOrdersWithinRange: async (facilityID, startDate, endDate) => {
        const url = `api/wholesale/v1/doordash/orders?facilityID=${facilityID}&startDate=${startDate}&endDate=${endDate}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getPOCredits: async (startDate, endDate) => {
        const url = `api/wholesale/v1/doordash/purchaseOrderCredit?startDate=${startDate}&endDate=${endDate}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getPurchaseOrderCreditReasons: async () => {
        const url = `api/wholesale/v1/doordash/purchaseOrderCredit/reasons`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getPurchaseOrderDetails: async (poNum) => {
        const url = `api/wholesale/v1/doordash/purchaseOrders/${poNum}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getPricing: async () => {
        const url = `api/wholesale/v1/doordash/pricing`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getPackoutRows: async (facilityID) => {
        const url = `api/wholesale/v1/doordash/packout?facilityID=${facilityID}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getPrintableBatches: async (facilityID) => {
        const url = `api/wholesale/v1/doordash/batches/printable?facilityID=${facilityID}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getPrintableBatchesDetails: async (key, value, deliveryDate) => {
        const url = `api/wholesale/v1/doordash/batches/printable/details?${key}=${value}&deliveryDate=${deliveryDate}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getPrintedBatches: async (facilityID) => {
        const url = `api/wholesale/v1/doordash/batches/printed?facilityID=${facilityID}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    getShipmentDetails: async (shipmentID) => {
        const url = `api/wholesale/v1/doordash/orders/details/${shipmentID}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    issuePOCredit: async (items) => {
        const url = `api/wholesale/v1/doordash/purchaseOrderCredit`;
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(items),
        });
        return response;
    },
    markDelivered: async (sendParams) => {
        const url = `api/wholesale/v1/doordash/orders/delivered`;
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify(sendParams),
        });
        return response;
    },
    printBatch: async (facilityID, key, value, deliveryDate) => {
        const url = `api/wholesale/v1/doordash/batches/print?facilityID=${facilityID}&${key}=${value}&deliveryDate=${deliveryDate}`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = 'doordashbatch.pdf';
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(res);
                    }
                }, 200);
            }
        } catch (e) {
            console.error('[doorDashApi - printBatch] error', e.toString());
        }
    },
    reprintBatch: async (batchID) => {
        const url = `api/wholesale/v1/doordash/batches/reprint?batchID=${batchID}`;
        try {
            const res = await mmFetch(url);
            if (res.ok === true) {
                const blob = await res.blob();
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                    return;
                }

                const d = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                document.body.appendChild(link);
                link.href = d;
                link.download = 'doordashbatch.pdf';
                link.click();

                setTimeout(() => {
                    if (window.URL && typeof window.URL.revokeObjectURL === 'function') {
                        window.URL.revokeObjectURL(res);
                    }
                }, 200);
            }
        } catch (e) {
            console.error('[doorDashApi - reprintBatch] error', e.toString());
        }
    },
    sendInvoice: async (id) => {
        const url = `api/wholesale/v1/doordash/invoices`;
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: JSON.stringify({ id }),
        });
        return response;
    },
    sendPackoutFile: async (facilityID, packedDate) => {
        const url = `api/wholesale/v1/doordash/sendPackoutFile?facilityID=${facilityID}&packedDate=${packedDate}`;
        const response = await mmFetchWithResponse(url);
        return response;
    },
    updateMicroFulfillmentCenter: async (id, item) => {
        const url = `api/wholesale/v1/doordash/microFC/${id}`;
        const response = await mmFetchWithResponse(url, {
            method: 'PUT',
            body: JSON.stringify(item),
        });
        return response;
    },
    uploadAllocation: async (data, facilityID) => {
        const formData = new FormData();
        formData.append('allocationFile', data.file);

        const url = `api/wholesale/v1/doordash/allocation/bulk?facilityID=${facilityID}`;
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: formData,
            processData: false,
            headers: {},
        });
        return response;
    },
    uploadOrders: async (data) => {
        const formData = new FormData();
        formData.append('orderFile', data.file);

        const url = 'api/wholesale/v1/doordash/orders/bulk';
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: formData,
            processData: false,
            headers: {},
        });
        return response;
    },
    uploadPricing: async (data) => {
        const formData = new FormData();
        formData.append('pricingFile', data.file);

        const url = 'api/wholesale/v1/doordash/pricing/upload';
        const response = await mmFetchWithResponse(url, {
            method: 'POST',
            body: formData,
            processData: false,
            headers: {},
        });
        return response;
    },
};

export { doorDashApi };
